import { Col, Row, Card } from "antd";
import { useEffect, useState, useRef } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const CardCollapse = ({ children, subContent, cardClassName, icon, title }) => {
  const [view, setView] = useState(false);
  const cardRef = useRef(null);

  const onViewChange = () => {
    setView(!view);
  };

  useEffect(() => {
    const currentRef = cardRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.8 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Card
      ref={cardRef}
      className={cardClassName}
      title={
        title && (
          <Row justify={"space-between"} onClick={onViewChange}>
            <Col className="flex-center">
              <img src={icon} alt="stops" className="icon20 mr05" />
              {title}
            </Col>
            <Col className="font-weight-normal">
              {view ? (
                <>
                  Hide
                  <UpOutlined className="ml05" />
                </>
              ) : (
                <>
                  Show
                  <DownOutlined className="ml05" />
                </>
              )}
            </Col>
          </Row>
        )
      }
    >
      {subContent}
      {view ? children : null}
    </Card>
  );
};

export default CardCollapse;
